import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-order",
  "use": "icon-order-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"icon-order\">\r\n<path d=\"M7.4,0.3H4.6C4.3,0.3,4.1,0.6,4.1,1c0,0.4,0.3,0.6,0.6,0.6h2.7c0.3,0,0.6-0.3,0.6-0.6C7.9,0.6,7.7,0.3,7.4,0.3L7.4,0.3\r\n\tL7.4,0.3z M8.9,1c0,0.8-0.2,1.3-1,1.3l-3.9,0c-0.8,0-1-0.6-1-1.3H1.8c-0.5,0-1,0.4-1,1v8.8c0,0.6,0.3,1,1,1h8.4c0.5,0,1-0.3,1-1V1.9\r\n\tc0-0.6-0.4-1-1-1H8.9z M8.6,9.1H3.5c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.3,0.3-0.3h5.1c0.2,0,0.3,0.1,0.4,0.3\r\n\tC8.9,8.9,8.8,9.1,8.6,9.1L8.6,9.1L8.6,9.1z M8.5,6.8H3.4c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3h5.1c0.2,0,0.3,0.1,0.4,0.3\r\n\tC8.9,6.6,8.7,6.8,8.5,6.8L8.5,6.8L8.5,6.8z M8.5,4.5H3.4c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3h5.1c0.2,0,0.3,0.1,0.4,0.3\r\n\tC8.9,4.4,8.7,4.5,8.5,4.5L8.5,4.5L8.5,4.5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/order.svg
// module id = gYtG
// module chunks = 221